export const QUESTIONS: string[] = [
  "Eğer bir gün sonsuz sürseydi ve onu seninle geçirebilseydim, nerede ve nasıl geçirirdik?",
  "Seni en çok korkutan şey nedir? Bu korkunun kaynağını biliyor musun?",
  "Hayatında bir şeyi değiştirebilseydin ama sadece tek bir şeyi ne olurdu?",
  "Bana hiç söylemediğin ama söylemek istediğin bir şey var mı?",
  "Şu an ne hissediyorsun? Tek kelimeyle değil, gerçekten.",
  "Kendini en çok hangi anda özgür hissediyorsun?",
  "Çocukken olmak istediğin o kişi oldun mu?",
  "Seninle aynı şeyi hissettiğimi ilk fark ettiğin an hangisiydi?",
  "Hiç utanmadan ağladığın bir an var mıydı? Ne olmuştu?",
  "Seni tanıyan ama yanlış anlayan biri var mı hayatında?",
  "Gelecekte hayal ettiğin en sıradan ortak günümüz nasıl görünüyor?",
  "Hayatında en çok neyi erteliyorsun ve bunun gerçek nedeni ne?",
  "Birlikte hiç yapmadık ama bir gün mutlaka yapmak istediğin şey nedir?",
  "Sessizliği rahat bulur musun yoksa seni gergin mi eder?",
  "Seni en çok mutlu eden küçük, önemsiz görünen şeyler neler?",
  "Bir insanın karakter olarak en değerli özelliği sence nedir?",
  "Geçmişte verdiğin en cesur karar hangisiydi?",
  "Beni en çok hangi anımızda gerçekten tanıdığını düşünüyorsun?",
  "Yorgun ve bunalmış hissedince ne yapmak seni iyi hissettiriyor?",
  "Hayatında seni en çok şekillendiren kişi kim oldu ve neden?",
  "Rüyanda sık sık gördüğün bir yer ya da his var mı?",
  "Kendinle yalnız kaldığında aklına en çok ne geliyor?",
  "Birlikte geçirdiğimiz anlardan hangisini hiç unutmak istemezsin?",
  "Seni anlamayan biriyle karşılaştığında nasıl bir his oluyor?",
  "Başarı sana göre gerçekten ne anlama geliyor?",
  "Bir yerden ayrılmak zorunda kalsaydın, en çok neyi özlerdin?",
  "Şimdiye kadar aldığın en iyi tavsiye neydi? Kimden?",
  "Seninle ilgili çoğu insanın farkında olmadığı bir şey nedir?",
  "Mutluluk ile huzur arasındaki farkı hissediyor musun? Hangisi daha çok sende?",
  "Eğer bugün son günün olsaydı, ilk kimi arardın?",
  "Beni gördüğünde içinden ne geçiyor, gerçekten?",
  "Sence ikimizin en derin ortak noktası ne?",
  "Kendine en çok ne zaman yabancı hissediyorsun?",
  "Aşkın zamanla değiştiğini düşünüyor musun? Nasıl?",
  "Bu ilişkide seni en çok büyüten şey ne oldu?",
  "Beş yıl sonra nasıl biri olmak istiyorsun?",
  "Seni en son ne için gurur duydum sence?",
  "Hayatında neye en çok zaman harcıyorsun ama aslında istemiyorsun?",
  "Birlikte kaçıp bir hafta ortadan kaybolabilseydik, ne yapardık?",
  "Geceleri uyumadan önce en çok ne düşünüyorsun?",
  "Sevildiğini en çok hangi anda hissediyorsun?",
  "Bir şeyi sevmediğinde bunu söylemek sana zor mu geliyor?",
  "Şu an hayatında en çok neye minnettarsın?",
  "Beni en son ne zaman şaşırttım?",
  "Seni kim olduğun için kabul eden kaç kişi var hayatında?",
];

export function getDayQuestion(dateKey: string) {
  const [y, m, day] = dateKey.split('-').map(Number);
  const d = new Date(y, m - 1, day);
  const start = new Date(d.getFullYear(), 0, 0);
  const diff = d.getTime() - start.getTime();
  const dayOfYear = Math.floor(diff / 86400000);
  return QUESTIONS[dayOfYear % QUESTIONS.length];
}
